import { Outlet } from 'react-router-dom'
import { Box } from '@chakra-ui/react'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import Header from './Header'
import { useState } from 'react'

export default function Root() {
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  return (
    <>
      <Box minHeight="100vh" position="relative" margin="0 auto">
        {/* <Header /> */}
        <Outlet />
        {/* <Footer /> */}
        {/* <ReactQueryDevtools /> */}
      </Box>
    </>
  )
}
